import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core'

export const ProgressBar = ({ percentage, title }: { percentage: number, title?: string }) => {
  const { progressBar } = styles()
  const [displayPercent, setDisplayPercent] = useState(0)

  setTimeout(() => setDisplayPercent(percentage), 10)

  return (
    <div className={progressBar}>
      <div className="bar" style={{ width: `${displayPercent}%` }}></div>
      { title ? <p>{title}</p> : null }
    </div>
  )
}

const styles = makeStyles({
  '@keyframes growIn': {
    from: { maxHeight: 0, opacity: 0 },
    to: { maxHeight: 1000, opacity: 1 },
  },

  progressBar: {
    animation: '$growIn 0.5s forwards',
    background: '#807A8D',
    borderRadius:  0,
    color: '#FFF',
    height: 24,
    margin: 0,
    fontSize: 14,
    overflow: 'visible',
    position: 'relative',
    width: '100%',

    // Used so that a bunch of progress bars have a slight delay transitioning to their current value
    ...Array(50).fill(undefined).reduce((acc, v, i) => ({
      [`&:nth-of-type(${i+1})`]: {
        '& .bar': {
          'transitionDelay': `${.05*i}s`,
        },
      },
      ...acc,
    }), {}),

    '& .bar': {
      background: '#1087CE',
      width: 0,
      height: 24,
      transition: 'all 1s ease-in-out',
    },

    '& p': {
      position: 'absolute',
      zIndex: 2,
      top: 2,
      left: 12,
      lineHeight: '1.5em',
      margin: 0,
    },
  },
})
